export const actionTypes = {
    FETCH_ORDERS_SUCCESS: 'ORDERS/FETCH_ORDERS_SUCCESS',
    FETCH_ORDER_BY_ID: 'ORDERS/FETCH_ORDER_BY_ID',
    FETCH_ORDER_BY_ID_SUCCESS: 'ORDERS/FETCH_ORDER_BY_ID_SUCCESS',
    FETCH_ORDER_BY_ID_ERROR: 'ORDERS/FETCH_ORDER_BY_ID_ERROR',

    ORDER_SET_ACTIVE: 'ORDERS/ORDER_SET_ACTIVE',
};
